import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme(
    {
        palette: {
            primary: {
                main: '#b2ebf2',
            },
            secondary: {
                main: '#81b9bf'
            }
        }
    }
);

export default theme;
